(function() {
  'use strict';
  angular.module('benefits')
  .component('insuranceInfo', {
    bindings: {
      refId: '='
    },
    controller: ['benefitService', 'planNameFilter', '$translate','asyncYamlLoader', '$rootScope',
      function memberInfoController(benefitService, planNameFilter, $translate, asyncYamlLoader, $rootScope) {
      this.$onInit = function() {
        var ctrl = this;
        ctrl.applicationName = $rootScope.applicationName;
        asyncYamlLoader().then(function(values) {

          benefitService.planSummaryPromise.then(function(data) {
            ctrl.model = data;
            if (ctrl.name && ctrl.model.medicareAdvantage ) {
              ctrl.payerId = values.medicareAdvantage.payerId.text;
            }
          });

          benefitService.getMemberByRefId(ctrl.refId).then((data) => {
            if (!data) {
              return;
            }
            if(values.billingAddress[data.corpCode]) {
              ctrl.address = values.billingAddress[data.corpCode].address;
              ctrl.cityStateZip = values.billingAddress[data.corpCode].cityStateZip;
              ctrl.name = values.billingAddress[data.corpCode].name;
              ctrl.payerId = ctrl.model && ctrl.model.medicareAdvantage ? values.medicareAdvantage.payerId.text : values.billingAddress[data.corpCode].payerId;
            } else {
              ctrl.billingAddress = "Not Available";
              ctrl.payerId = "Not Available";
            }
          });
        });
      };
    }],
    templateUrl: 'js/benefits/insuranceInfo.html' + appVersion
  });
})();
